"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cumsum;

function cumsum(values, valueof) {
  var sum = 0,
      index = 0;
  return Float64Array.from(values, valueof === undefined ? v => sum += +v || 0 : v => sum += +valueof(v, index++, values) || 0);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/victory-vendor/lib-vendor/d3-array/src/cumsum.js
// module id = 4283
// module chunks = 0